import { defineMessages } from 'react-intl';

type MessageKeys = 'skillBetaTag';

const messages: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		skillBetaTag: {
			id: 'rovo-platform-ui-components.skills.skill-hover-card-content.skillBetaTag',
			defaultMessage: 'Beta',
			description:
				'Text shown in a lozenge badge next to the skill name in the skill hover card when the skill is in beta. It indicates that the skill is not yet fully released and may still be under development.',
		},
	});

export default messages;
